import { useTheme } from "@material-ui/core";
import clsx from "clsx";
import Image from "next/image";
import React from "react";
import { twMerge } from "tailwind-merge";

import { Text } from "@/features/common/components/tailwind/Text";
import { TouchableView } from "@/features/common/components/tailwind/TouchableView";
import { View } from "@/features/common/components/tailwind/View";

interface JoinSubscriptionPaymentButtonLayoutProps {
  active: boolean;
  onClick?: () => void;
  label: string;
}

export const JoinSubscriptionPaymentButton: React.FC<JoinSubscriptionPaymentButtonLayoutProps> =
  (props) => {
    const theme = useTheme();
    const { label, active, onClick = () => {} } = props;
    const border = `1px solid ${
      active ? theme.palette.primary.main : theme.palette.grey[600]
    }`;

    return (
      <TouchableView
        onClick={onClick}
        className={twMerge(
          active ? "border-primary-700 bg-primary-200" : "border-gray-500",
          "flex justify-center relative p-4 border",
        )}
      >
        <Text size="normal" className={active && "text-primary-700"}>
          {label}
        </Text>
        {active && (
          <View className="absolute -top-2.5 -right-2.5">
            <Image
              alt="tick"
              layout="fixed"
              height={20}
              width={20}
              src="/assets/common/tick.png"
            />
          </View>
        )}
      </TouchableView>
    );
  };
